import { graphql } from '../gql';

export const getCompletedEvents = graphql(`
  query GetCompletedEvents(
    $startTimeAfter: ISO8601DateTime
    $startTimeBefore: ISO8601DateTime
    $vendorIds: [ID!]!
  ) {
    searchEventVendors(
      input: {
        startTimeAfter: $startTimeAfter
        startTimeBefore: $startTimeBefore
        vendorIds: $vendorIds
        eventStatuses: [COMPLETE, FINAL]
        vendorStatuses: [ACTIVE]
        perspective: RESTAURANT
        includeLiveDeliveryStatus: true
      }
    ) {
      error {
        code
        message
      }
      eventVendors(first: 50) {
        nodes {
          __typename
          id
          productType
          ... on PopupEventVendor {
            vendor {
              id
              internalName
            }
            popupEvent {
              id
              startTime: eventStartTime
              endTime: eventEndTime
              status
              account {
                id
                name
              }
            }
            eventLocation {
              id
              setupTime
              serviceStartTime
              location {
                id
                name
                building {
                  id
                  name
                  address {
                    id
                    address1
                    address2
                    city
                    state
                    zipCode
                    country
                  }
                }
                cafeLocation {
                  id
                  name
                }
              }
            }
          }
          ... on SelectEventVendor {
            aggregateManifestKey
            foodDelivered
            vendor {
              id
              internalName
            }
            selectEvent {
              id
              startTime: endTime
              endTime: deliveryTime
              status
              readyAndBaggedTime
              account {
                id
                name
              }
              location {
                id
                name
                building {
                  id
                  name
                  address {
                    id
                    address1
                    address2
                    city
                    state
                    zipCode
                    country
                  }
                }
              }
            }
          }
          ... on CateringEventVendor {
            vendor {
              id
              internalName
            }
            event {
              name
              id
              startTime
              endTime
              status
              setupTime
              account {
                id
                name
              }
              location {
                id
                name
                building {
                  id
                  name
                  address {
                    id
                    address1
                    address2
                    city
                    state
                    zipCode
                    country
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);
